import {Grid, Typography} from '@mui/material';
import {useVerifyCouponController} from 'modules/auth';
import {FormView} from 'shared/components';
import {useLangContext} from 'shared/features/Language';
import {VerifyForm} from './VerifyForm';
import {FC} from 'react';
import {Container} from "@mui/material";

type Props = {
  imageId: string;
};
export const PublicAuthView: FC<Props> = ({imageId}) => {
  const {initFormData, enter, loading, error} = useVerifyCouponController(imageId);
  const {textData} = useLangContext();

  return (
    <Container
      sx={{
        height: '100%',
        maxWidth: {lg: '1200px', xs: '980px' },
        marginInline: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant='body2'
        sx={{
          maxWidth: {lg: '1000px', xs: '800px' },
          marginTop: {lg: '50px', xs: '10px' },
          textAlign: 'center'
        }}
      >
        {textData.verifyCodeTitle}
      </Typography>

        <Grid container spacing={2}
              sx={{
                justifyContent: 'center'
              }}
        >
          {!!error && (
            <Grid item sx={{textAlign: 'center'}}>
              <Typography
                variant="overline"
                sx={{
                  fontSize: {lg: '20px', md: '16px', xs: '14px'},
                  fontWeight: 300,
                  lineHeight: '120%',
                  color: '#F00',
                }}
              >
                {textData.verifyError}
              </Typography>
            </Grid>
          )}

          <Grid item sx={{marginTop: {lg: '0px', md: '0px', xs: '0px'}}}>
            <FormView
              formData={initFormData}
              component={VerifyForm}
              componentProps={{isLoading: loading.verify}}
              onSubmit={enter}
              errorList={!!error ? [{field: 'code', message: ''}] : undefined}
            />
          </Grid>
        </Grid>
    </Container>
  );
};
